module.exports = __webpack_public_path__ + "static/media/judgeme-product-reviews.ee56edde.png";